import React from 'react';
import PropTypes from 'prop-types';
import { ActionType } from '../action-type';
import { Notifications } from '../notifications';

const originalNotifications = {
  [ActionType.Sms]: false,
  [ActionType.Email]: false,
};

export const CarrierNotifications = ({ onChange, inputValueProps }) => {
  const currentNotifications = inputValueProps.parameter ? JSON.parse(inputValueProps.parameter) : originalNotifications;

  const onChangeNotifications = (notifications) => {
    const rule = {
      parameter: JSON.stringify(notifications),
    };
    onChange(rule);
  };

  return <Notifications notifications={currentNotifications} onChange={onChangeNotifications} />;
};

CarrierNotifications.propTypes = {
  onChange: PropTypes.func.isRequired,
  inputValueProps: PropTypes.shape({
    parameter: PropTypes.string,
  }).isRequired,
};
